import React from 'react';

import { Flex } from 'antd-v5';
import { ErrorBoundary } from 'react-error-boundary';

import styles from './PageContainer.module.scss';

export default function PageContainer(
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  props: React.PropsWithChildren<{}>,
) {
  return (
    <ErrorBoundary FallbackComponent={() => <div />}>
      <Flex className={styles.pageContainer} vertical>
        {props.children}
      </Flex>
    </ErrorBoundary>
  );
}
